var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gift-card-value"},[_c('span',{staticClass:"gift-card-value__label"},[_vm._v("Gift Card")]),_c('span',{staticClass:"gift-card-value__amount"},[_vm._v(_vm._s(_vm.amount_label))])])
}
var staticRenderFns = []

export { render, staticRenderFns }